import { g as getWindowScroll } from './getWindowScroll-ac827e65.js';
import { g as getWindow } from './getWindow-3a67409b.js';
import { b as isHTMLElement } from './instanceOf-f2c9fcdf.js';
import { g as getHTMLElementScroll } from './getHTMLElementScroll-0a1d760c.js';

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

export { getNodeScroll as g };
//# sourceMappingURL=getNodeScroll-137ad895.js.map
